import React, { useEffect, useState } from "react";
import axios from "axios";
import CustomPagination from "../../components/Pagination";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { formatDate, trimAddress, copyToClipboard } from "../../helper/helper";
import { IoCopyOutline } from "react-icons/io5";

import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const FiatTransaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [activeTab, setActiveTab] = useState("apps");
  const [isLoading, setIsLoading] = useState(false);

  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleTransferClick = (data) => {
    setSelectedWithdraw(data);
    setShowModal(true);
  };

  const PaymentStatus = {
    "": "Select",
    "PENDING FROM ADMIN SIDE": "PENDING FROM ADMIN SIDE",
    "PARTIALLY SUCCESS": "PARTIALLY SUCCESS",
    SUCCESS: "SUCCESS",
  };
  const handleDropdownChange = (e) => {
    setDropdownValue(e.target.value); // store the key (e.g., "PENDING")
    setSearchQuery(""); // reset search query
    setCurrentPage(1); // reset pagination
  };

  const fetchAppsTransaction = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/merchant-app-tx/merchant-fiat-withdraw-list-admin`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            pageNo: currentPage,
            limitVal: 10,
            search: dropdownValue ? dropdownValue : searchQuery,
          },
        }
      );

      console.log("response 112", response);

      setTransactions(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPaymentTransaction = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/payment-link/admin-all-payments`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            pageNo: currentPage,
            limitVal: 10,
            search: dropdownValue ? dropdownValue : searchQuery,
          },
        }
      );

      setTransactions(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Debounce search to avoid API calls on every keystroke
    const delayTimer = setTimeout(() => {
      if (activeTab === "apps") {
        fetchAppsTransaction();
      } else if (activeTab === "payment") {
        fetchPaymentTransaction();
      }
    }, 500); // 500ms delay

    return () => clearTimeout(delayTimer);
  }, [currentPage, searchQuery, activeTab, dropdownValue]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setDropdownValue("");
    setCurrentPage(1);
  };

  const handleConfirmTransfer = async () => {
    try {
      setIsLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchant-app-tx/admin-fiat-transfer?fiatWithdrawId=${selectedWithdraw?._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.succes("Fiat transferred successfully!");

      setShowModal(false);
      fetchAppsTransaction(); // reload updated data
    } catch (error) {
      console.log("ERRORORORORORR", error);
      alert(error.response?.data?.message || "Transfer failed");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  console.log("fiat transactions", transactions);

  return (
    <div>
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "400px",
              background: "white",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <h4>Confirm Transfer</h4>
            <p>
              Are you sure you want to transfer withdrawal of{" "}
              <strong>{selectedWithdraw?.withdrawlAmount}</strong> USD ?
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-success"
                onClick={handleConfirmTransfer}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 d-flex justify-content-between">
              <div className="col-sm-6">
                <h1 className="m-0">Fiat Transactions</h1>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <div style={{ position: "relative", flex: 1, maxWidth: "500px" }}>
                        <input
                          style={{
                            width: "100%",
                            padding: "5px 35px 5px 10px",
                            borderRadius: "5px",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ccc",
                          }}
                          type="text"
                          placeholder="Search by merchant, app, currency, amount, status..."
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                        {isLoading && (
                          <div style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}>
                            <i className="fas fa-spinner fa-spin"></i>
                          </div>
                        )}
                      </div>

                      <div>
                        <select
                          style={{
                            marginLeft: "10px",
                            width: "300px",
                            height: "36px",
                            padding: "5px",
                            borderRadius: "5px",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ccc",
                          }}
                          value={dropdownValue}
                          onChange={handleDropdownChange}
                          className="form-select"
                        >
                          {Object.entries(PaymentStatus).map(
                            ([key, value], index) => (
                              <option key={key} value={key}>
                                {" "}
                                {value}{" "}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Merchant Name</th>
                            <th>App Name</th>
                            <th>Total Fiat Balance</th>
                            <th>WithDrawl Amount</th>
                            <th>Currency</th>
                            <th>Crypto Value</th>
                            <th>Status</th>
                            <th>Time Stamp</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions?.length ? (
                            transactions.map((data, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data?.merchantId?.name}</td>
                                <td>{data?.appsId?.name}</td>
                                <td>{data?.appsId?.totalFiatBalance}</td>
                                <td>{data?.withdrawlAmount}</td>
                                <td>{data?.currency}</td>
                                <td>{data?.cryptoValue}</td>

                                <td>{data.status}</td>
                                <td>{formatDate(data?.createdAt)}</td>
                                {/* <td>
                                  {data.status !== "SUCCESS" ? (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => handleTransferClick(data)}
                                    >
                                      Transfer
                                    </button>
                                  ) : (
                                    <span
                                      style={{
                                        color: "green",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Done
                                    </span>
                                  )}
                                </td> */}

                                <td>
                                  <Link
                                    to={`/fiat-transaction-view/${data?._id}`}
                                    className="btn btn-link merch-view"
                                  >
                                    <i className="fas fa-eye"></i>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    marginTop: "20px",
                                  }}
                                >
                                  <p>No Data found</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiatTransaction;
